/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PaymentMethodsCard,
  PaymentMethodsCard$inboundSchema,
  PaymentMethodsCard$Outbound,
  PaymentMethodsCard$outboundSchema,
} from "./paymentmethodscard.js";

export type CardPaymentPaymentMethod = {
  /**
   * ID of the payment method.
   */
  paymentMethodID: string;
  paymentMethodType: "card-payment";
  /**
   * A card as contained within a payment method.
   */
  card: PaymentMethodsCard;
};

/** @internal */
export const CardPaymentPaymentMethod$inboundSchema: z.ZodType<
  CardPaymentPaymentMethod,
  z.ZodTypeDef,
  unknown
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("card-payment"),
  card: PaymentMethodsCard$inboundSchema,
});
/** @internal */
export type CardPaymentPaymentMethod$Outbound = {
  paymentMethodID: string;
  paymentMethodType: "card-payment";
  card: PaymentMethodsCard$Outbound;
};

/** @internal */
export const CardPaymentPaymentMethod$outboundSchema: z.ZodType<
  CardPaymentPaymentMethod$Outbound,
  z.ZodTypeDef,
  CardPaymentPaymentMethod
> = z.object({
  paymentMethodID: z.string(),
  paymentMethodType: z.literal("card-payment"),
  card: PaymentMethodsCard$outboundSchema,
});

export function cardPaymentPaymentMethodToJSON(
  cardPaymentPaymentMethod: CardPaymentPaymentMethod,
): string {
  return JSON.stringify(
    CardPaymentPaymentMethod$outboundSchema.parse(cardPaymentPaymentMethod),
  );
}
export function cardPaymentPaymentMethodFromJSON(
  jsonString: string,
): SafeParseResult<CardPaymentPaymentMethod, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => CardPaymentPaymentMethod$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CardPaymentPaymentMethod' from JSON`,
  );
}
